import React from "react";
import "./emergency.css";
import { countryEmergNum } from "../../Data";
import Footer from "../../components/Footer/Footer";

import ProfileNavbar from "../../components/Navbar/ProfileNavbar";

const items = countryEmergNum;
console.log(items);

const Emergency = () => {
  return (
    <>
    <ProfileNavbar/>
    <div className="emergency">
      <h1>Emergency Page</h1>
      <p>
        <span style={{ color: "red" }}>NOTE:</span> If you need immediate
        emergency assistance, check the emergency numbers and websites below
        that can help you in your situation according to where you are from.
      </p>
      {items.map((item, idx) => (
        <div className="emerg-table" key={idx}>
          <h1>{item.country}</h1>
          <div className="emerg-row emerg">
            <p>Emergency</p>
            <p>{item.emergency}</p>
          </div>
          <div className="emerg-row">
            <p>{item.suicidePrevention[0]}</p>
            <p>{item.suicidePrevention[1]}</p>
          </div>
          <div className="emerg-row">
            <p>{item.number[0]}</p>
            <p>{item.number[1]}</p>
          </div>
          <div className="emerg-row">
            <p>{item.website[0]}</p>
            <p>
              <a href={item.website[2]}>{item.website[1]}</a>
            </p>
          </div>
        </div>
      ))}
    </div>
    <Footer />
    </>

  );
};

export default Emergency;
